<!-- <div class="w-50 mt-5">
<div *ngIf="isInvoicesLoaded && userInvoiceDetail" class="card shadow">
  <div class="card-header bg-secondary text-white">
    <h5 class="card-title mb-0">Invoice Details</h5>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="mt-2"><strong>Invoice Number: </strong> {{ userInvoiceDetail.InvoiceNumber }}</div>
        <div class="mt-2"><strong>Customer Name: </strong> {{ userInvoiceDetail.CustomerName }}</div>
        <div class="mt-2"><strong>Customer Email: </strong> {{ userInvoiceDetail.CustomerEmail }}</div>
        <div class="mt-2"><strong>Amount Paid: </strong> {{ userInvoiceDetail.AmountPaid | currency:'USD':'symbol':'1.2-2'}}</div>
        <div class="mt-2"><strong>Payment Status: </strong> <span class="badge bg-success text-capitalize">{{userInvoiceDetail.Status }}</span></div>
        <div class="mt-2"><strong>Paid Date: </strong> {{ userInvoiceDetail.PaidAt | date:'dd/MM/yyyy hh:mm a'}}</div>
        <div class="mt-2"><strong>Billing Address: </strong>{{ userInvoiceDetail.CustomerAddress }}</div>
        <div class="mt-4">
          <a href="{{ userInvoiceDetail.InvoicePdfUrl }}" target="_blank"
          class="btn btn-primary btn-sm">View Invoice</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isInvoicesLoaded && !userInvoiceDetail" class="alert alert-warning mt-4" role="alert">
  There're no registered invoices against your account
</div>
</div> -->
<div>
  @if (isInvoicesLoaded) {
    <div class="card">
      <div class="card-header bg-secondary text-white">
        <h4 class="card-title mb-0">{{ 'viewUserInvoice.subscriptionDetails' | transloco }}@if (planInterval) {
          <span class="ms-2 fs-4">({{planInterval}})</span>
        }</h4>
      </div>
      <div class="card-body">
        <div class="d-flex flex-row justify-content-between">
          <div class="d-flex flex-column">
            @if (createdDate) {
              <span><strong class="me-2 text-uppercase">{{ 'viewUserInvoice.createdDate' | transloco }} </strong> {{createdDate | date: 'dd/MM/yyyy HH:mm'}}</span>
            }
            @if (currentPeriod) {
              <span><strong class="me-2 text-uppercase">{{ 'viewUserInvoice.currentPeriod' | transloco }} </strong> {{currentPeriod}}</span>
            }
            @if (nextInvoice) {
              <span><strong class="me-2 text-uppercase">{{ 'viewUserInvoice.nextInvoice' | transloco }} </strong> {{nextInvoice}}</span>
            }
          </div>
          <div>
            <button class="btn btn-outline-danger btn-sm px-2 py-1 me-1" (click)="onCancelSubscription(subscriptionId)">{{ 'viewUserInvoice.cancelSubscription' | transloco }}</button>
          </div>
        </div>
        <div>
          @if (invoices && invoices.length > 0) {
            <div class="table-responsive mt-3">
              <p-table #dt [value]="invoices" dataKey="Id" [rowHover]="true"
                styleClass="p-datatable-gridlines p-datatable-striped"
                [globalFilterFields]="['InvoiceNo','PaidAmount', 'PaidDate', 'Status']" selectionMode="single" [paginator]="invoices.length > 15"
                [rows]="10" [reorderableColumns]="true" [resizableColumns]="false">
                <ng-template pTemplate="caption">
                  <div class="table-header">
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <div
                          class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                          <button type="button"
                            class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                            <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                          </button>
                          <input type="text"
                            class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                            (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'viewUserInvoice.search' | transloco" />
                          </div>
                        </div>
                        <div class="col-md-6 text-left"></div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
                    <tr>
                      <th class="text-center" [pSortableColumn]="'InvoiceNo'">
                        {{ 'viewUserInvoice.invoiceNumber' | transloco }}<p-sortIcon [field]="'InvoiceNo'"></p-sortIcon>
                      </th>
                      <th class="text-center text-uppercase" [pSortableColumn]="'PaidAmount'" style="width: 220px;">
                        {{ 'viewUserInvoice.amount' | transloco }}<p-sortIcon [field]="'PaidAmount'"></p-sortIcon>
                      </th>
                      <th class="text-center text-uppercase" [pSortableColumn]="'PaidDate'" style="width: 180px;">
                        {{ 'viewUserInvoice.date' | transloco }} <p-sortIcon [field]="'PaidDate'"></p-sortIcon>
                      </th>
                      <th class="text-center text-uppercase" [pSortableColumn]="'Status'" style="width: 180px;">
                        {{ 'viewUserInvoice.status' | transloco }} <p-sortIcon [field]="'Status'"></p-sortIcon>
                      </th>
                      <th class="text-center text-uppercase" style="width: 300px;">{{ 'viewUserInvoice.download' | transloco }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
                    <tr>
                      <td class="text-center">{{rowData.InvoiceNo}}</td>
                      <td class="text-center">{{rowData.PaidAmount | currency: 'USD' }}</td>
                      <td class="text-center">
                        {{rowData.PaidDate | date: 'dd/MM/yyyy HH:mm'}}
                      </td>
                      <td class="text-center"><span class="badge bg-success-subtle text-capitalize text-success">{{rowData.Status}}</span></td>
                      <td class="text-center">
                        <a [href]="rowData.InvoicePdf" target="_blank"><i class="pi pi-download"></i></a>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="6">
                        <div class="text-center">{{ 'viewUserInvoice.noInvoicesFound' | transloco }}</div>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>